//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DepartmentAssessment',
  components: {
    merits: function merits() {
      return import('./components/merits');
    },
    auditProcess: function auditProcess() {
      return import('./components/auditProcess');
    }
  },
  data: function data() {
    return {
      tabCur: '6',
      id: 0,
      checkBtn: true,
      isTips: true,
      addBtn: false,
      status: 0,
      strType: '',
      tabButton: true,
      handle: 1
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    // 评价成功
    saveOk: function saveOk() {
      this.checkBtn = true;
      this.getList();
    },
    meritsHandleCheck: function meritsHandleCheck(res, str) {
      this.strType = str;
      this.checkBtn = false;
      this.status = res.status;
      this.id = res.id;
      if (res.addBtn > 1) {
        this.isTips = false;
        this.addBtn = true;
      } else {
        this.isTips = true;
        this.addBtn = false;
      }
    },
    auditProcess: function auditProcess(data) {
      if (data.return == 1) {
        this.checkBtn = true;
        this.tabButton = true;
        this.getList();
      }
    },
    tapClick: function tapClick() {
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      var tabCur = parseInt(this.tabCur);
      setTimeout(function () {
        _this.handle = tabCur === 6 ? 1 : '';
        _this.$refs.merits.getFormBoxFrame();
        if (_this.checkBtn) {
          _this.$refs.merits.getTableData();
        }
      }, 300);
      this.tabButton = false;
    }
  }
};